<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <MergeDataForm
        ref="mergeDataForm"
        v-model="mergeDataForm"
        label-width="10em"
        formMode="search"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import MergeDataForm from '@/components/organisms/dialog/data/MergeDataForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    MergeDataForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      mergeDataForm: {
        billing_ym: this.getDefaultBillingYm(),
        registration_symbol: undefined,
        action_type: undefined,
        action_time: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        callsign: undefined,
        route_code: undefined,
        operator_code: undefined,
        bill_to_code: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        flight_purpose_code: undefined,
        flight_type: undefined,
        irregular: undefined,
        use_data_status: undefined,
        error_data_only: false,
        calculate_All_Data: false,
        billing_exclusion_data_only: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.mergeDataForm.clearFields()
    },
    clickSearch () {
      this.$refs.mergeDataForm.validate()
        .then((valid) => {
          sessionStorage.setItem('mergeDataSearchCond', JSON.stringify(this.mergeDataForm))
          this.dialogVisible = false
          this.$emit('search', this.mergeDataForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('mergeDataSearchCond'))
      this.$nextTick(() => {
        this.$refs.mergeDataForm.clearFields()
        if (searchCond) {
          Object.keys(this.mergeDataForm).forEach((x) => {
            this.$set(this.mergeDataForm, x, searchCond[x])
          })
          if (!this.mergeDataForm.error_data_only) {
            this.mergeDataForm.error_data_only = false
          }
          if (!this.mergeDataForm.calculate_All_Data) {
            this.mergeDataForm.calculate_All_Data = false
          }
          if (!this.mergeDataForm.billing_exclusion_data_only) {
            this.mergeDataForm.billing_exclusion_data_only = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-search-dialog {
  ::v-deep .el-form-item {
    &.remarks {
      display: none;
    }
  }
}
</style>
